import { Pipe, PipeTransform } from '@angular/core';
import {
    ZatcaInvoiceState,
    ZatcaInvoiceStateLabelsEn,
    ZatcaInvoiceStateTranslations,
} from 'src/app/core/interfaces/zatca-invoice-state.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({
    name: 'ZatcaInvoiceState',
    pure: false
})
export class ZatcaInvoiceStatePipe implements PipeTransform {
    constructor(private localizationService: LocalizationService) { }

    transform(value: ZatcaInvoiceState | string): string {
        if (!value) return '';
        const lang = this.localizationService.getCachedLanguage();
        const labels = lang === 'ar' ? ZatcaInvoiceStateTranslations : ZatcaInvoiceStateLabelsEn;
        return labels[value as ZatcaInvoiceState] || value;
    }
}
